// Domains app content: one long string per page (Notepad view)
export const DOMAINS_TEXT = [
  `clang.ai
  
anti-aging.ai

bio-hacking.ai

usenergy.ai

bmwgroup.ai

urbantech.ai

iotsecurity.ai

bioprinting.ai

gametech.ai
  
carbonclean.ai

freebeats.ai

economical.ai
  
enhancedreality.ai

paleontology.ai

holographics.ai

appliedquantum.ai

telesolutions.ai

bioelectronics.ai

vlogging.ai

sellads.ai

exoskeletons.ai

aihacks.ai

selfesteem.ai

findapartments.ai

findhouses.ai

freeprescriptions.ai

spacecolony.ai

autogenerative.ai

teleoperations.ai`,
];
